export default function isString(maybe) {
    return typeof maybe === 'string';
}



// WEBPACK FOOTER //
// ./src/widget/ScrollBar/utils/isString.js